import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l5 5l5 -5","key":"svg-0"}],["path",{"d":"M7 13l5 5l5 -5","key":"svg-1"}]]

/**
 * IconChevronsDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbnMtZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA3bDUgNWw1IC01IiAvPgogIDxwYXRoIGQ9Ik03IDEzbDUgNWw1IC01IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/chevrons-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronsDown = createReactComponent('outline', 'chevrons-down', 'ChevronsDown', __iconNode);

export default IconChevronsDown;